import React, { useState, useEffect, useRef } from 'react';
import * as actionTypes from '../../../redux/actions/actionTypes';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import { Form, Input, Radio, Modal, Spin /* Button */ } from 'antd';
import SmallText from '../../../components/SmallText/SmallText';
import LabelInput from '../../../components/LabelInput/LabelInput';
import ControlloCF from '../../../components/ControlloCF/ControlloCF';
import FormSteps from '../Form/Form';
import getDatiCodiceFiscale from '../../../redux/actions/mock/getDatiCodiceFiscale';
import { useSelector, useDispatch } from 'react-redux';
import Immagine from '../../../components/Immagine/Immagine';
import moment from 'moment';

const DatiPersonali = () => {
  const erroriSalvaStep = useSelector(
    state => state.dataReducer.salvaStep.dati
  );
  const loadingCodiceFiscale =
    useSelector(state => state.dataReducer.load.loadingCodiceFiscale) || false;
  const erroreMessaggioControlloCodiceFiscale = useSelector(
    state => state.dataReducer.datiCodiceFiscale.errorMessage
  );
  const apiPath = useSelector(state => state.dataReducer.dataApiPath);
  const [errorMessageCodiceFiscale, setErrorMessageCodiceFiscale] =
    useState(null);

  const [modalVisibleTrasparenza, setModalVisibleTrasparenza] = useState(false);
  const [helpNome, setHelpNome] = useState(null);
  const [helpCognome, setHelpCognome] = useState(null);
  const accettazionePrivacyPolicy = useSelector(
    state => state.dataReducer.modello.datiPratica.informativaPrivacy
  );

  const documentiTrasparenza = useSelector(
    state => state.dataReducer.documentiPdf.documentiTrasparenza
  );
  const dispatch = useDispatch();
  const datiCF = useSelector(
    state => state.dataReducer.datiCodiceFiscale || {}
  );
  const anni18Richiedente =
    datiCF.dataNascita !== ''
      ? moment(datiCF.dataNascita).add(18, 'years')
      : null;
  const annoAttuale = moment();

  const linkInformativa = useSelector(
    state => state.dataReducer.documentiPdf.linkInformativa
  );

  // const linkFiliali = useSelector(state => state.dataReducer.documentiPdf.linkFiliali);
  // const clienteCCBStore = useSelector(state => state.dataReducer.modello.datiPratica.correntistaCcb);
  // const [modalVisibleCCB,setModalVisibleCCB] = useState(true);

  const datiTokenInBank = useSelector(
    state => state.dataReducer.datiTokenInBank
  );
  const refCF = useRef(null);
  const [disabledNome, setDisabledNome] = useState(false);
  const [disabledCognome, setDisabledCognome] = useState(false);
  const [disabledCF, setDisabledCF] = useState(false);

  useEffect(() => {
    if (datiTokenInBank && refCF.current) {
      const codiceFiscale = refCF.current?.input?.value;
      if (codiceFiscale) {
        controlloCF(codiceFiscale);
      }
      setDisabledNome(setDisabledItem('nome'));
      setDisabledCognome(setDisabledItem('cognome'));
      setDisabledCF(setDisabledItem('codiceFiscale'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (erroriSalvaStep) {
      erroriSalvaStep.forEach(errore => {
        switch (errore.errorCode) {
          case 'codiceFiscale':
            setErrorMessageCodiceFiscale(errore.errorMessage);
            break;
          default:
            setErrorMessageCodiceFiscale(null);
            break;
        }
      });
    } else {
      setErrorMessageCodiceFiscale(null);
    }
  }, [erroriSalvaStep]);

  function showModalTrasparenza() {
    setModalVisibleTrasparenza(!modalVisibleTrasparenza);
  }

  function controlloCF(element) {
    const codiceFiscale =
      typeof element === 'string'
        ? element
        : element?.target?.value || element?.currentTarget?.value || '';
    if (codiceFiscale.length === 16) {
      setErrorMessageCodiceFiscale(null);
      dispatch({ type: actionTypes.LOADING_CF_TRUE });
      dispatch(getDatiCodiceFiscale(codiceFiscale, apiPath));
    }
  }

  function controlloNome(e) {
    const re = /^[a-zA-Zòàèìù' ]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setHelpNome(null);
    } else {
      setHelpNome('Inserire solo valori non numerici');
    }
  }

  function controlloCognome(e) {
    const re = /^[a-zA-Zòàèìù' ]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      setHelpCognome(null);
    } else {
      setHelpCognome('Inserire solo valori non numerici');
    }
  }

  function changePrivacySwitch(e) {
    dispatch({ type: actionTypes.CHANGE_PRIVACY_CHECKBOX, payload: e });
  }

  const setDisabledItem = field => {
    if (datiTokenInBank) {
      let elem = datiTokenInBank.find(item => item.field === field);
      if (elem) {
        return !JSON.parse(elem.editable);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  /* function clienteCCB(){
        dispatch({ type: actionTypes.CAMBIO_CLIENTE_CCB, payload:true})
        showModalCCB();
    } */

  /* function showModalCCB(){
        setModalVisibleCCB(!modalVisibleCCB);
    } */

  return (
    <div className={stylesForm.Form}>
      <HeaderStep titolo="Dati Personali" sottotitolo="" />

      <FormSteps
        formId="step1"
        bloccoAvanzamento={
          helpNome === null &&
          helpCognome === null &&
          annoAttuale.diff(anni18Richiedente) > 0 &&
          accettazionePrivacyPolicy
            ? false
            : true
        }>
        <Form.Item
          name="nome"
          help={helpNome}
          rules={[
            {
              required: true,
              pattern: new RegExp(/^[a-zA-Z\\\\'òàèùì ]+$/i),
              message: 'Inserisci il tuo nome!',
            },
          ]}>
          <Input
            onChange={controlloNome}
            disabled={disabledNome}
            placeholder="nome"
            maxLength="50"
            suffix={
              <label className={stylesForm.floatingLabel} htmlFor="nome">
                Nome*
              </label>
            }
          />
        </Form.Item>

        <Form.Item
          name="cognome"
          help={helpCognome}
          rules={[
            {
              required: true,
              message: 'Inserisci il tuo cognome!',
            },
          ]}>
          <Input
            onChange={controlloCognome}
            disabled={disabledCognome}
            placeholder="cognome"
            maxLength="50"
            suffix={
              <label className={stylesForm.floatingLabel} htmlFor="cognome">
                Cognome*
              </label>
            }
          />
        </Form.Item>

        <Form.Item
          name="codiceFiscale"
          help={
            erroreMessaggioControlloCodiceFiscale
              ? erroreMessaggioControlloCodiceFiscale
              : errorMessageCodiceFiscale
          }
          rules={[
            {
              required: true,
              message: 'Inserisci il tuo codice fiscale!',
            },
            {
              len: 16,
              message: 'Prolunga questo testo a 16 caratteri',
            },
          ]}>
          <Input
            ref={refCF}
            onChange={controlloCF}
            disabled={disabledCF}
            minLength="16"
            maxLength="16"
            placeholder="codice fiscale"
            suffix={
              <label
                className={stylesForm.floatingLabel}
                htmlFor="codiceFiscale">
                Codice Fiscale*
              </label>
            }
          />
        </Form.Item>

        <Spin spinning={loadingCodiceFiscale}>
          <ControlloCF loading={loadingCodiceFiscale} />
        </Spin>

        {/* <SmallText description={1} clicked={showModalTrasparenza} linkInformativa={linkInformativa} changePrivacyCheckbox={changePrivacyCheckbox} /> */}
        <SmallText description={4} />

        <LabelInput
          text="Marketing per prodotti di Prestipay e/o prodotti di Terzi (3.3)"
          openPopUp="MKT"
        />
        <Form.Item
          name="consensoMkt"
          rules={[
            {
              required: true,
              message: 'Accetta o nega il consenso',
            },
          ]}>
          <Radio.Group>
            <Radio.Button value={true}>Do il consenso</Radio.Button>
            <Radio.Button value={false}>Nego il consenso</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <LabelInput
          text="Cessione di dati personali a Terzi - Marketing (3.5)"
          openPopUp="Terzi"
        />
        <Form.Item
          name="consensoTerzi"
          rules={[
            {
              required: true,
              message: 'Accetta o nega il consenso',
            },
          ]}>
          <Radio.Group>
            <Radio.Button value={true}>Do il consenso</Radio.Button>
            <Radio.Button value={false}>Nego il consenso</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <LabelInput text="Profilazione (3.4)" openPopUp="Marketing" />
        <Form.Item
          name="consensoMarketing"
          rules={[
            {
              required: true,
              message: 'Accetta o nega il consenso',
            },
          ]}>
          <Radio.Group>
            <Radio.Button value={true}>Do il consenso</Radio.Button>
            <Radio.Button value={false}>Nego il consenso</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <LabelInput
          text="Cessione di dati personali a Terzi - Prevalutazione Prodotti di Terzi (3.6)"
          openPopUp="consentFourth"
        />
        <Form.Item
          name="consentFourth"
          rules={[
            {
              required: true,
              message: 'Accetta o nega il consenso',
            },
          ]}>
          <Radio.Group>
            <Radio.Button value={true}>Do il consenso</Radio.Button>
            <Radio.Button value={false}>Nego il consenso</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <SmallText clicked={showModalTrasparenza} description={2} />

        <SmallText
          description={3}
          currentValue={accettazionePrivacyPolicy}
          clicked={showModalTrasparenza}
          linkInformativa={linkInformativa}
          changePrivacyCheckbox={changePrivacySwitch}
        />

        <Modal
          onCancel={showModalTrasparenza}
          open={modalVisibleTrasparenza}
          closeIcon={<Immagine urlImage={'close-modal.svg'} name="close" />}>
          <h2>Documenti Trasparenza</h2>
          <p>
            Prima di procedere scarica e salva la seguente documentazione di
            trasparenza.
          </p>

          {documentiTrasparenza
            ? documentiTrasparenza.map(documento => (
                <a
                  key={documento.link}
                  href={documento.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={stylesForm.DownloadTrasparenza}>
                  <Immagine urlImage={'xls.svg'} name="xlsx" />{' '}
                  {documento.label}
                </a>
              ))
            : null}
        </Modal>
      </FormSteps>
    </div>
  );
};

export default DatiPersonali;
